import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import Footer from '../components/Footer';
import Reveal from '../components/Reveal';

const BookingPortal = () => {
  const [customerName, setCustomerName] = useState('');
  const [customerEmail, setCustomerEmail] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');
  const [address, setAddress] = useState('');
  const [date, setDate] = useState('');
  const [time, setTime] = useState('09:00');
  const [accessType, setAccessType] = useState('Ground Level');
  const [waterState, setWaterState] = useState('Full');
  const [notes, setNotes] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const { error } = await supabase.from('tankcare_appointments').insert([{
        user_id: null,
        customer_name: customerName,
        customer_email: customerEmail,
        customer_phone: customerPhone,
        appointment_date: date,
        appointment_time: time,
        address: address,
        service_type: 'cleaning',
        status: 'pending'
      }]);
      if (error) throw error;
      setSuccess(true);
      // Reset form
      setCustomerName('');
      setCustomerEmail('');
      setCustomerPhone('');
      setAddress('');
      setDate('');
      setTime('09:00');
      setAccessType('Ground Level');
      setWaterState('Full');
      setNotes('');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
{/* Main Content */}
<main className="pt-28 flex-grow w-full max-w-container-max mx-auto px-margin-mobile md:px-margin-desktop py-8 md:py-12">
<Reveal>
<div className="grid grid-cols-1 lg:grid-cols-12 gap-gutter">
{/* Left Column: Form Content */}
<div className="lg:col-span-12 flex flex-col gap-8">

{/* Success Message */}
{success ? (
  <div className="glass-panel p-8 md:p-12 rounded-xl text-center">
    <div className="w-20 h-20 bg-primary-container/10 rounded-full flex items-center justify-center mx-auto mb-6">
      <span className="material-symbols-outlined text-primary text-4xl" style={{ fontVariationSettings: "'FILL' 1" }}>check_circle</span>
    </div>
    <h2 className="font-headline-md text-headline-md text-on-surface mb-3">Booking Confirmed!</h2>
    <p className="font-body-lg text-body-lg text-on-surface-variant mb-8 max-w-md mx-auto">Your tank cleaning appointment has been submitted successfully. We'll contact you shortly to confirm.</p>
    <button 
      onClick={() => setSuccess(false)} 
      className="bg-primary-container text-on-primary-container px-8 py-3 rounded-lg font-body-md font-medium hover:opacity-90 transition-opacity shadow-sm flex items-center gap-2 mx-auto"
    >
      Book Another Appointment
      <span className="material-symbols-outlined">add</span>
    </button>
  </div>
) : (
<form className="glass-panel p-8 rounded-xl" onSubmit={handleSubmit}>
{error && <div className="bg-error-container text-on-error-container p-4 rounded-lg mb-6">{error}</div>}
<h2 className="font-headline-md text-headline-md text-on-surface mb-6 font-semibold pt-6 border-t border-outline-variant/30">Personal Details & Schedule</h2>
<div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
  <div className="flex flex-col gap-2">
    <label className="font-label-sm text-label-sm text-on-surface-variant uppercase">Full Name</label>
    <input type="text" className="w-full bg-surface-container-lowest border border-outline-variant rounded-lg px-4 py-3 text-on-surface focus:border-primary-container focus:ring-1 focus:ring-primary-container" value={customerName} onChange={(e) => setCustomerName(e.target.value)} required />
  </div>
  <div className="flex flex-col gap-2">
    <label className="font-label-sm text-label-sm text-on-surface-variant uppercase">Email Address</label>
    <input type="email" className="w-full bg-surface-container-lowest border border-outline-variant rounded-lg px-4 py-3 text-on-surface focus:border-primary-container focus:ring-1 focus:ring-primary-container" value={customerEmail} onChange={(e) => setCustomerEmail(e.target.value)} placeholder="your@email.com" required />
  </div>
  <div className="flex flex-col gap-2">
    <label className="font-label-sm text-label-sm text-on-surface-variant uppercase">Phone Number</label>
    <input type="tel" className="w-full bg-surface-container-lowest border border-outline-variant rounded-lg px-4 py-3 text-on-surface focus:border-primary-container focus:ring-1 focus:ring-primary-container" value={customerPhone} onChange={(e) => setCustomerPhone(e.target.value)} required />
  </div>
  <div className="flex flex-col gap-2">
    <label className="font-label-sm text-label-sm text-on-surface-variant uppercase">Preferred Date</label>
    <input type="date" className="w-full bg-surface-container-lowest border border-outline-variant rounded-lg px-4 py-3 text-on-surface focus:border-primary-container focus:ring-1 focus:ring-primary-container" value={date} onChange={(e) => setDate(e.target.value)} required />
  </div>
  <div className="flex flex-col gap-2">
    <label className="font-label-sm text-label-sm text-on-surface-variant uppercase">Preferred Time</label>
    <input type="time" className="w-full bg-surface-container-lowest border border-outline-variant rounded-lg px-4 py-3 text-on-surface focus:border-primary-container focus:ring-1 focus:ring-primary-container" value={time} onChange={(e) => setTime(e.target.value)} required />
  </div>
</div>
<h2 className="font-headline-md text-headline-md text-on-surface mb-6 font-semibold pt-6 border-t border-outline-variant/30">Location Details</h2>
<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
<div className="md:col-span-2 flex flex-col gap-2">
  <label className="font-label-sm text-label-sm text-on-surface-variant uppercase">Service Address</label>
  <input type="text" className="w-full bg-surface-container-lowest border border-outline-variant rounded-lg px-4 py-3 text-on-surface focus:border-primary-container focus:ring-1 focus:ring-primary-container" value={address} onChange={(e) => setAddress(e.target.value)} placeholder="Enter your full address..." required />
</div>
<div className="flex flex-col gap-2">
<label className="font-label-sm text-label-sm text-on-surface-variant uppercase">Access Type</label>
<select value={accessType} onChange={(e) => setAccessType(e.target.value)} className="w-full bg-surface-container-lowest border border-outline-variant rounded-lg px-4 py-3 focus:outline-none focus:border-primary-container focus:ring-1 focus:ring-primary-container text-on-surface font-body-md transition-all">
<option>Ground Level</option>
<option>Rooftop (Elevator Access)</option>
<option>Rooftop (Stairs Only)</option>
<option>Underground</option>
</select>
</div>
<div className="flex flex-col gap-2">
<label className="font-label-sm text-label-sm text-on-surface-variant uppercase">Current Water State</label>
<select value={waterState} onChange={(e) => setWaterState(e.target.value)} className="w-full bg-surface-container-lowest border border-outline-variant rounded-lg px-4 py-3 focus:outline-none focus:border-primary-container focus:ring-1 focus:ring-primary-container text-on-surface font-body-md transition-all">
<option>Empty</option>
<option>Partially Full</option>
<option>Full</option>
</select>
</div>
<div className="md:col-span-2 flex flex-col gap-2">
<label className="font-label-sm text-label-sm text-on-surface-variant uppercase">Additional Notes for Technicians</label>
<textarea value={notes} onChange={(e) => setNotes(e.target.value)} className="w-full bg-surface-container-lowest border border-outline-variant rounded-lg px-4 py-3 focus:outline-none focus:border-primary-container focus:ring-1 focus:ring-primary-container text-on-surface font-body-md transition-all min-h-[100px] resize-none" placeholder="e.g., Gate code is 1234, beware of dog..."></textarea>
</div>
</div>
<div className="mt-8 flex justify-between items-center pt-6 border-t border-outline-variant/30">
<button type="submit" disabled={loading} className="bg-primary-container text-on-primary-container px-8 py-3 rounded-lg font-body-md font-medium hover:opacity-90 transition-opacity shadow-sm flex items-center gap-2 disabled:opacity-50">{loading ? "Processing..." : "Submit Booking"} <span className="material-symbols-outlined">arrow_forward</span></button>
</div>
</form>
)}
</div>
</div>
</Reveal>
</main>
{/* Footer */}
<Footer />
    </>
  );
};
export default BookingPortal;